// Not generated from samples: written from Appboy::Communication::Segment::B2bFilter.

import { z } from "zod";

// One account condition (B2bFilter#get_filter_json returns query_conditions[:conditions] as stored). A new filter
// starts with every key null (B2bFilter.default_value). The value comes from the nested filter inputs (b2b.ts), so
// it takes the nested property value shapes; an existence comparison has no value, so the key is dropped.
export const b2bFilterConditionSchema = z.object({
  account_field_name: z.string().nullable(),
  account_field_value: z
    .union([z.boolean(), z.number(), z.string(), z.array(z.string())])
    .nullable()
    .optional(),
  comparison: z.string().nullable(),
  comparison_type: z.string().nullable(),
});
